import { LoadingOutlined } from "@ant-design/icons";

export const getConfig = ({ loading, t, projectData, data, getCountry }) => [
  {
    key: 'country',
    title: t('Country'),
    img: '/assets/images/dashboard/project/country.png',
    render: () => loading ? <LoadingOutlined size="small" />
      : projectData ? getCountry(projectData.country) : t('Loading')
  },
  {
    key: 'locations',
    title: t('Locations'),
    img: '/assets/images/dashboard/project/locations.svg',
    render: () => loading ? <LoadingOutlined size="small" /> :
      data ? Number(data.locations?.totalItems || 0).toLocaleString("en-US") : 0
  },
  {
    key: 'stakeholders',
    title: t('Stakeholders'),
    img: '/assets/images/dashboard/project/stakeholders.svg',
    render: () => loading ? <LoadingOutlined size="small" /> :
      data ? Number(data.stakeholders?.totalItems || 0).toLocaleString("en-US") : 0
  },
  {
    key: 'events',
    title: t('Events'),
    img: '/assets/images/dashboard/project/events.svg',
    render: () => loading ? <LoadingOutlined size="small" /> :
      data ? Number(data.events?.totalItems || 0).toLocaleString("en-US") : 0
  },
  {
    key: 'lirs',
    title: t('LIRs'),
    img: '/assets/images/dashboard/project/lirs.svg',
    render: () => loading ? <LoadingOutlined size="small" /> :
      data ? Number(data.network?.totalItems || 0).toLocaleString("en-US") : 0
  },
  {
    key: 'documents',
    title: t('Documents'),
    img: '/assets/images/dashboard/project/documents.svg',
    render: () => loading ? <LoadingOutlined size="small" /> :
      data ? Number(data.documents?.totalItems || 0).toLocaleString("en-US") : 0
  },
];
